/* Kay Galerie header B "Wall label" (sections/kg-header.liquid). */
(function () {
  var root = document.querySelector('[data-kgh]');
  if (!root) return;
  var home = root.classList.contains('kgh--home');
  var label = root.querySelector('[data-kgh-label]');
  var GAP = 72; /* the full label needs this much air above the hero text, or it shows its compact form */

  function onScroll() { root.classList.toggle('is-scrolled', window.scrollY > 60); }
  function fit() {
    if (!label || window.scrollY > 10) return;
    var copy = document.querySelector('.kg-licht__copy');
    if (!copy) return;
    root.classList.remove('is-tight');
    if (label.getBoundingClientRect().bottom + GAP > copy.getBoundingClientRect().top) root.classList.add('is-tight');
  }
  if (home) {
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', fit);
    window.addEventListener('load', fit);
    onScroll(); fit();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
  }

  root.querySelectorAll('[data-kgh-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var li = btn.closest('li');
      var open = li.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', String(open));
    });
  });

  var room = root.querySelector('[data-kgh-room]');
  var words = room && room.querySelector('.kgh__words');
  var opener = null;
  function openRoom(focusSearch, btn) {
    opener = btn || document.activeElement;
    room.classList.add('is-open');
    room.removeAttribute('inert');
    room.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('kgh-lock');
    root.querySelectorAll('[data-kgh-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    setTimeout(function () {
      var t = focusSearch ? room.querySelector('input[type="search"]') : room.querySelector('[data-kgh-close]');
      if (t) t.focus({ preventScroll: true });
    }, 80);
  }
  function closeRoom() {
    room.classList.remove('is-open');
    room.setAttribute('inert', '');
    room.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('kgh-lock');
    root.querySelectorAll('[data-kgh-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (opener && opener.focus) opener.focus({ preventScroll: true });
  }
  if (room) {
    root.querySelectorAll('[data-kgh-open]').forEach(function (b) {
      b.addEventListener('click', function () { openRoom(b.getAttribute('data-kgh-open') === 'search', b); });
    });
    room.querySelector('[data-kgh-close]').addEventListener('click', closeRoom);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && room.classList.contains('is-open')) closeRoom(); });
    room.addEventListener('pointermove', function (e) {
      if (!words) return;
      var r = words.getBoundingClientRect();
      words.style.setProperty('--ox', (e.clientX - r.left) + 'px');
      words.style.setProperty('--oy', (e.clientY - r.top) + 'px');
    });
  }

  root.querySelectorAll('[data-kgh-loc]').forEach(function (btn) {
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (!panel) return;
    btn.addEventListener('click', function () {
      var show = panel.hidden;
      panel.hidden = !show;
      btn.setAttribute('aria-expanded', String(show));
    });
    document.addEventListener('click', function (e) {
      if (!panel.hidden && !panel.contains(e.target) && !btn.contains(e.target)) {
        panel.hidden = true;
        btn.setAttribute('aria-expanded', 'false');
      }
    });
  });
  root.querySelectorAll('.kgh__loc-form select').forEach(function (s) {
    s.addEventListener('change', function () { s.form.submit(); });
  });
})();